module.exports = __webpack_public_path__ + "media/images/icon-check-fill-20ae962958f697247a5ed2b2bccb1de3.svg";